<template>
  <div>
    
    <modal :id="id" :title="title">
      <span v-html="politica"></span>
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/modal/Modal";
import TermosService from "@/common/services/termos/termos.service";
import Swal from "sweetalert2";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

export default {
  name: "Politica",
  props: {
    title: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "modal-politica",
    },
    funcaoEnviar: {
      type: Function,
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      politica: "",
    };
  },
  methods: {
    listar() {
      this.$store.dispatch(START_LOADING);
      TermosService.getPolitica()
        .then((result) => {
          this.politica = result.data.data;
        })
        .catch((err) => {
          Swal.fire({
            title: this.$t("GERAL.ERRO"),
            text: err.response.data.errors,
            icon: "error",
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
  mounted() {
    this.listar();
  },
};
</script>
